<footer class='footer'>
  <div class='main-container'>
    <h2 class='sr-only'>stopka {{ name }}</h2>
    <div class='links' id='footer-links'>
      <a routerLink='/strona-glowna' class='logo'>
        <img [src]='appLogoPath' alt='' width='30' aria-hidden='true'>
        <span class='sr-only'>Strona główna <span class='sr-only'>{{ name }}</span></span> {{ name }}
      </a>
      <ul class="subpages">
        <li><a routerLink='/jak-korzystac'>Jak korzystać</a></li>
        <li><a routerLink='/info/aplikacja-mobilna'>Aplikacja mobilna</a></li>
        <li><a routerLink='/info/o-projekcie'>O projekcie</a></li>
        <li><a routerLink='/info/polityka-prywatnosci'>Polityka prywatności</a></li>
        <li><a routerLink='/info/regulamin'>Regulamin</a></li>
        <li><a routerLink='/info/deklaracja-dostepnosci'>Deklaracja dostępności</a></li>
        <li><a routerLink='/info/kontakt'>Kontakt</a></li>
      </ul>
      <br>
    </div>
    @if (showFooterEULogotypes) {
      <div class='eu-logotypes'>
        <img src="/img/icons/eu/loga_ue.jpg"
             alt="Logotypy: Fundusze Europejskie dla Wielkopolski, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską, Samorząd Województwa Wielkopolskiego">
      </div>
    }
    <div>
      <small>
        Zadanie dotyczy realizowanego przez Gminę Wronki projektu pn. „E-usługi publiczne dla mieszkańców Gminy Wronki”,
        o numerze FEWP.01.03-IZ.00-0007/23-00, współfinansowanego ze środków Unii Europejskiej w ramach Programu
        Regionalnego Fundusze Europejskie dla Wielkopolski 2021-2027, Priorytet 1: Fundusze europejskie dla
        wielkopolskiej gospodarki, Działanie 1.3 Rozwój e-usług i e-zasobów publicznych.
      </small>
    </div>
  </div>
</footer>
<div class='appVersion'>Version: {{ version }}</div>
